import { z } from "zod";
/**
 * Team members — a minimal, read-only projection of the tenant's staff
 * (sourced from Clerk via staff-users.service) used to power people pickers
 * (task Lead/Support, and later the email composer + share modals).
 *
 * Distinct from `StaffUserSchema`: no role, status, ids, or invite metadata —
 * just enough to render "Name — email" and store the chosen email.
 *
 * This is a RESPONSE schema, so it stays LOOSE (house rule): `email` is a
 * plain string, not `.email()`, and names are nullable. A single legacy or
 * system-generated row must never blank the whole picker.
 */
// Named `TeamDirectoryMember` (not `TeamMember`) to avoid colliding with the
// project-team membership schema in projects.ts — different concept: this is
// the tenant-wide staff directory, that is per-project team assignment.
export const TeamDirectoryMemberSchema = z.object({
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
});
export const TeamMemberListResponseSchema = z.object({
    members: z.array(TeamDirectoryMemberSchema),
});
//# sourceMappingURL=team.js.map